import { render } from "./gerenciar-escalas.vue?vue&type=template&id=42b66700"
import script from "./gerenciar-escalas.vue?vue&type=script&lang=js"
export * from "./gerenciar-escalas.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__